<div class="container">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <div class="row">
      <div class="col-md-5">
        <img src="assets/img/search.png" alt="pesquisa" title="" width="42" height="42" >
        <span
          [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade m-0' : 'titulo-txt-normal fonte-acessibilidade m-0'">PESQUISA
          GERAL</span>
      </div>
      <div class="col-md-7">
        <a type="button" routerLink="/transparencia/portal" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="30" width="30">
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 pt-2">
        <label style="font-weight: bold; color: #757575">
          {{login.orgao.codigo}} {{login.orgao.nome}}
        </label>
      </div>
      <div class="col-md-4">
      </div>
    </div>
    <div class="row" *ngIf="listaGeral && listaGeral.length === 0">
      <div class="col-12">
        <i class="fa fa-exclamation-triangle" style="font-size: 20px"></i>
        <span [ngClass]="this.login.contraste ? 'text-white ml-1' : 'text-black-50 ml-1'">Não foram encontrados
          registros cadastrados!</span>
      </div>
    </div>
    <div class="row" *ngIf="listaGeral && listaGeral.length > 0">
      <div class="col-12">
        <div class="table-responsive">
          <table
            [ngClass]="login.contraste ? 'table table-dark fonte-acessibilidade' : 'table table-eddy fonte-acessibilidade'">
            <thead>
              <tr>
                <th scope="col">Id.</th>
                <th scope="col">Data</th>
                <th scope="col">Referência</th>
                <th scope="col">Nome</th>
                <th scope="col">Documento</th>
                <th scope="col">Valor</th>
                <th scope="col">#</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of listaGeral">
                <td>{{item.numero}}</td>
                <td>{{item.data | date:'dd/MM/yyyy':'GMT'}}</td>
                <td>{{item.referencia}}</td>
                <td>{{item.nome}}</td>
                <td>{{item.documento}}</td>
                <td>{{item.valor | number:'1.2-2'}}</td>
                <td *ngIf="item.tipo === 'empenho'"><span class="badge badge-primary">{{item.tipo}}</span></td>
                <td *ngIf="item.tipo === 'contrato'"><span class="badge badge-success">{{item.tipo}}</span></td>
                <td *ngIf="item.tipo === 'remuneracao'"><span class="badge badge-warning">{{item.tipo}}</span></td>
                <td class="text-right" style="min-width: 100px">
                  <button (click)="buscar(item)" routerLinkActive="router-link-active"
                    class="btn btn-sm btn-outline-secondary mr-2">
                    <img src="assets/img/global/zoom.png" alt="editar" height="16" width="16">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
